<template>
  <b-card>
    <!-- <b-row align-h="end">
      <b-col>
        <b-badge
          variant="light-warning"
          style="margin-bottom: 0px; padding: 10px; white-space: normal;"
        >
          O Certificado da Condição de Microempreendedor Individual (CC MEI) é consultado via e-CAC para as empresas MEI cadastradas.
        </b-badge>
      </b-col>
      <b-col cols="auto">
        <download-em-excel
          :filtro="filtroAtual"
          tipo="CcMei"
          alterar-style="font-size: 11.5px;padding: .65rem 2rem;"
          :api="apiCcMei"
        />
      </b-col>
      <b-col cols="auto">
        <download-em-lote
          tipo-arquivo="todos CC MEI"
          tipo="CcMei"
          :filtro="filtroAtual.filtroBy"
          alterar-style="font-size: 11.5px;padding: .45rem 1rem;"
          @baixar-lote="baixarEmLote"
        />
      </b-col>
    </b-row> -->
    <cc-mei-list
      ref="ccMeiList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
    >
      <template
        slot="custom"
        slot-scope="{ props }"
      >
        <b-badge
          v-if="props.column.field === 'situacaoCadastral'"
          :variant="getVariantSituacao(props.row[props.column.field])"
        >
          {{ props.row[props.column.field] }}
        </b-badge>
      </template>
      <template
        slot="acoes"
        slot-scope="{ props }"
      >
        <acoes
          :ref="`acoes${props.row.id}`"
          :grid-props="props"
          @atualizar-grid="atualizarGrid"
        />
      </template>
    </cc-mei-list>
  </b-card>
</template>

<style lang="scss">
.col-tamanho-cnpj {
  min-width: 194px !important;
}
</style>

<script>
import colunas from './config/colunas'
import filtrosRapidosConfig from './config/filtrosRapidos'
import api from './services/api'

export default {
  name: 'CcMeiView',
  components: {
    CcMeiList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    Acoes: () => import('./shared/components/acoes/Acoes.vue'),
    // DownloadEmLote: () => import('@app/download-lote/DownloadEmLote.vue'),
    // DownloadEmExcel: () => import('@app/download-excel/DownloadEmExcel.vue'),
  },
  data() {
    return {
      apiCcMei: api,
      botoesOption: null,
      visualizacao: {
        acaoClass: 'col-td-acao-2',
        disabledCheckbox: true,
        placeholderBusca: 'Buscar por Razão Social, CNPJ/CPF',
        colunas,
        evento: this.carregar,
      },
      filtros: [{ colunas: ['CadastroFederal', 'RazaoSocial', 'CadastroFederalSemMascara'], valor: null }],
      filtrosRapidos: filtrosRapidosConfig,
      filtroAtual: {},
    }
  },
  mounted() {
    this.aplicarFiltroQuery()
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  methods: {
    carregar(pagina, tamanhoPagina, filtro) {
      this.filtroAtual = filtro
      return api.getPaginado(pagina, tamanhoPagina, filtro)
    },

    baixarEmLote(evt) {
      api.baixaEmLote(this.filtroAtual, evt)
    },

    atualizarGrid() {
      this.$refs.ccMeiList.refresh()
    },

    getVariantSituacao(situacao) {
      if (!situacao) return 'light-success'
      const s = situacao.toUpperCase()
      if (s === 'ATIVA') return 'light-success'
      if (s === 'BAIXADO' || s === 'BAIXADA') return 'light-danger'
      if (s === '-') return 'light-primary'
      return 'light-warning'
    },

    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.ccMeiList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.ccMeiList.aplicarFiltro(params.busca, filtroRapido)
        }
      })
    },
  },
}
</script>
